/**
 * 怪物渲染组合：体型 + 调色板 + 变体
 * 用于屏幕间共享（屏 2 预览 / 屏 3 详情 / 屏 4 圈养 / 屏 5 对战）
 *
 * 五行系统：调色板按 5 元素分组（每元素 5 套，共 25 套）
 */

import { ALL_BODY_TYPES } from "./elements";
import type { Element } from "../shared/types";

export interface Screen2Combo {
  bodyType: string;
  paletteName: string;
  variant: 0 | 1 | 2;
  element?: Element;
}

function shuffleInPlace<T>(arr: T[]): void {
  for (let i = arr.length - 1; i > 0; i--) {
    const j = Math.floor(Math.random() * (i + 1));
    [arr[i], arr[j]] = [arr[j], arr[i]];
  }
}

/**
 * 25 个五行调色板名称
 */
export const ELEMENT_PALETTE_NAMES: Record<Element, string[]> = {
  金: ["SilverSteel", "Gold", "Copper", "Platinum", "Bronze"],
  木: ["Emerald", "Moss", "Bamboo", "Olive", "DeepWood"],
  水: ["Abyss", "Ice", "DeepOcean", "Cyan", "Mist"],
  火: ["Crimson", "Magma", "Ember", "Inferno", "Sunset"],
  土: ["Sand", "Earth", "Clay", "Stone", "MossRock"],
};

/**
 * 根据主导五行，生成 1 个匹配该五行的 combo
 */
export function pickRandomCombos(n: number = 1, element?: Element): Screen2Combo[] {
  const el: Element = element ?? "土";
  const elements: Element[] = ["金", "木", "水", "火", "土"];

  const result: Screen2Combo[] = [];
  for (let i = 0; i < n; i++) {
    // 体型：选该元素的 5 个体型中随机一个
    const bodyList = ALL_BODY_TYPES; // 25 个
    const startIdx = elements.indexOf(el) * 5;
    const bodyType = bodyList[startIdx + Math.floor(Math.random() * 5)];
    // 调色板：从该元素 5 套中随机
    const palettePool = ELEMENT_PALETTE_NAMES[el];
    const paletteName = palettePool[Math.floor(Math.random() * palettePool.length)];
    result.push({
      bodyType,
      paletteName,
      variant: Math.floor(Math.random() * 3) as 0 | 1 | 2,
      element: el,
    });
  }
  return result;
}